<script setup lang="ts">
// How a participant's result came about (RDT-400). Only direct input earns a tag: the questionnaire
// is the normal path, and until a result exists the value is unset. Support could not tell the two
// apart before, because a typed-in participant runs through the same statuses as one who answered.
// The label reuses the shared direct-input.dialog.title key ("Direkteingabe"), so no new translation
// is needed; a locale without it falls back to the raw value rather than an empty tag.
import { computed, type PropType } from "vue";
import { useI18n } from "vue-i18n";
import type { InputMode } from "../../types/PersologOnlineTypes.ts";

const props = defineProps({
    inputMode: { type: String as PropType<InputMode | null>, default: null },
});

const { t, te } = useI18n();

const LABEL_KEY = "direct-input.dialog.title";

const isDirectInput = computed(() => props.inputMode === "DIRECT_INPUT");
const label = computed(() => (te(LABEL_KEY) ? t(LABEL_KEY) : "DIRECT_INPUT"));
</script>

<template>
    <Tag
        v-if="isDirectInput"
        icon="pi pi-file-edit"
        severity="secondary"
        :value="label"
        data-cy="input-mode-direct-input"
        style="font-weight: normal"
    />
</template>
